import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/warehouse/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/warehouse/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/warehouse/remove', qs.stringify(params),options);

export const stop = (params, options) =>
  request.post('/api/v4ward/warehouse/stop', qs.stringify(params),options);

export const change = (params, options) =>
  request.post('/api/v4ward/warehouse/change', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/warehouse/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/warehouse/update', params,options);

export const getWarehouseList = (params, options) =>
  request.get('/api/v4ward/warehouse/getWarehouseList', Object.assign({}, options, { params }));
